<template lang="pug">
.input-select-container
  select.custom-input-select-json.rounded.transparent-button.small.text-medium(
    ref="selectElm"
    :value="value"
    @input="$emit('input', $event.target.value)"
    :disabled='disabled'
  )
    template(v-for='option in options')
      option(
        :value='option.value'
        v-html='option.text'
        :disabled='option.disabled'
        :style='`text-align-last: ${textAlign};`'
      )
  .select-arrow.p-2
    i.fa.fa-angle-down(
      style='color: #0092C9'
    )

  //- .text-small {{ value }}
</template>

<script>
/* eslint-disable max-len */

export default {
  props: {
    options: {},
    value: {},
    disabled: {
      default: false,
    },
    textAlign: {
      default: 'left',
      validator: val => ['left', 'right', 'center'].includes(val),
    },
  },
  watch: {
    options() {
      const OLD_VAL = this.value;
      this.$emit('input', null);
      setTimeout(() => {
        this.$emit('input', OLD_VAL);
        // console.log('!!');
      }, 50);
      // console.log('!!');
    },
  },
  computed: {
    // displayValue() {
    //   let selectedItem = this.options[0];
    //   this.options.forEach((elm) => {
    //     if (elm.value === this.value) {
    //       selectedItem = elm;
    //     }
    //   });
    //   // const selectedItem = this.options[this.value];
    //   console.log(selectedItem);
    //   if (selectedItem) {
    //     return this.options[this.value].text;
    //   }
    //   return '...';
    // },
  },
};
</script>

<style lang="scss">
.input-select-container {
  position: relative;
  .custom-input-select-json {
    color: #444;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    // background-color: #fff;

    padding: 8px;

    &::-ms-expand {
      display: none;
    }
    &:hover {
      border-color: #888;
    }
    &:focus {
      border-color: #aaa;
      // box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);
      // box-shadow: 0 0 0 3px -moz-mac-focusring;
      color: #222;
      outline: none;
    }
    option {
      font-weight: normal;
      font-size: 17px;
    }
  }
  .select-arrow {
    position: absolute;
    right: 0;
    top: 0;
  }
}

</style>
